export default function() {
  var nodes = new Array(this.size()), i = -1;
  this.each(function() { nodes[++i] = this; });
  return nodes;
}



// WEBPACK FOOTER //
// ./~/d3-selection/src/selection/nodes.js